import {
  HYDRATE_FROM_LOCAL_STORE,
  LOGOUT_COMPLETE,
  SSO_IDP_AUTH_START,
  SSO_IDP_AUTH_RECEIVE_CODE,
  SSO_IDP_AUTH_RECEIVE_TOKEN,
  NEX_SSO_AUTH_LOGIN_SUCCESS,
  NEX_SSO_AUTH_LOGIN_FAILURE,
} from '../../constants/actionTypes';
import { SSO_AUTH_TYPES } from '../../constants/auth';

import { has, isNil } from 'lodash';

const initialState = {
  ssoType: SSO_AUTH_TYPES.none,
  authStatus: 'INIT',
  nextPath: '/',
  configInfo: {},
  authParams: {
    state: null,
    nonce: null,
    pkce_code_verifier: null,
    pkce_code_challenge: null,
  },
  tokenParams: {
    code: null,
    id_token: null,
    access_token: null,
    saml_token: null,
  },
};

export const idpConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE_FROM_LOCAL_STORE:
      return hydrateSessionFromStore(state, action);

    case SSO_IDP_AUTH_START: {
      //action payload will contain state/nonce/pkce_code_verifier/pkce_code_challenge etc generated as part of auth
      return { ...state, ...action.payload };
    }

    case SSO_IDP_AUTH_RECEIVE_CODE: {
      let newTokenParams = { ...state.tokenParams, ...action.payload };
      return { ...state, status: 'CODE', tokenParams: newTokenParams };
    }

    case SSO_IDP_AUTH_RECEIVE_TOKEN: {
      let newTokenParams = { ...state.tokenParams, ...action.payload };
      return { ...state, status: 'TOKEN', tokenParams: newTokenParams };
    }

    case NEX_SSO_AUTH_LOGIN_SUCCESS:
      return { ...initialState, nextPath: state.nextPath };

    case NEX_SSO_AUTH_LOGIN_FAILURE:
    case LOGOUT_COMPLETE:
      return invalidateSession(state, action);

    default:
      return state;
  }
};

export default idpConfigReducer;

function hydrateSessionFromStore(state, action) {
  return has(action, 'idpConfig') && !isNil(action.idpConfig)
    ? { ...state, ...action.idpConfig }
    : { ...state };
}

function invalidateSession(state, action) {
  return { ...initialState };
}
